<template>
	<div class="book-detail">
		<!-- 图书信息 -->
		<div class="book-detail-info">
			<div class="cover">
				<img v-if="bookDetails.coverUrl" :src="bookDetails.coverUrl" :key="bookDetails.bookId" referrerpolicy="no-referrer" @error="handleErrorImage($event)"/>
				<img v-else :src="defaultCover()" :key="bookDetails.bookId"/>
			</div>
			<div class="right">
				<h1>{{ bookDetails.title }}</h1>
				<p>
					<span class="label">作者:</span>
					<span class="value">{{ bookDetails.author }}</span>
				</p>
				<p>
					<span class="label">出版社:</span>
					<span class="value">{{ bookDetails.publisher }}</span>
				</p>
				<p class="price">￥{{ bookDetails.price }}</p>
			</div>
		</div>
		<!-- 供应商 -->
		<van-cell-group class="collections-booksellers">
			<van-cell center :title="institution" value="馆藏链接" :url="isLibLink" v-if="isLibLink"/>
			<van-cell center title="供应商" :value="vendorName"/>
		</van-cell-group>
		<!-- 信息 -->
		<van-cell-group>
			<van-cell center title="ISBN" :value="bookDetails.isbn"/>
			<van-cell center title="出版时间" :value="bookDetails.publicationDate"/>
<!--			<van-cell center title="库存" :value="bookDetails.inventory"/>-->
		</van-cell-group>
		<!-- 内容简介+章节 -->
		<div class="book-detail-content">
			<!--内容简介-->
			<div v-if="bookDetails.content">
				<h3>内容简介</h3>
				<div class="content" v-html="bookDetails.content"></div>
			</div>
			<!-- 章节 -->
			<div v-if="catalogs && catalogs.length > 0">
				<h3>章节</h3>
				<div class="chapter">
					<p v-for="(item, index) in catalogs" :key="index">
						<template v-if="index < 5 || moreCatalog">
							{{ item }}
						</template>
					</p>
				</div>
				<div class="more" @click="moreCatalog =!moreCatalog" v-if="catalogs && catalogs.length > 5">
					{{ moreCatalog ? "收起" : "更多" }}
					<van-icon :name="[moreCatalog ? 'arrow-up' : 'arrow-down']"></van-icon>
				</div>
			</div>
		</div>
	</div>
	<!--
	<van-action-bar>
		<div class="left">
      <span class="van-submit-bar__price">
        ¥<span class="van-submit-bar__price-integer">{{ bookDetails.price }}</span>
      </span>
		</div>
		<van-action-bar-button type="warning" text="加入购物车" @click="addToCart"/>
		<van-action-bar-button type="danger" text="立即购买" @click="onConfirm"/>
	</van-action-bar>
	-->
</template>

<script>
import {defineComponent, computed, watch, ref} from 'vue';
import {getLibLink, isNotEmpty, randomBookCover, setCovers} from '@/utils/util';
import store from '@/store';
import {getBookdetails} from '@/api/carts';
import {addCart, cartCheck, confirm, checkDuplicate} from '@/api/carts';
import {getOrderVendor} from '@/api/vendor';
import {getCartNum, getConsignee} from '@/api/users';
import {Toast, Dialog} from 'vant';
import {useRouter} from "vue-router";

export default defineComponent({
	name: 'OrderBookDetail',
	props: {
		bookId: {
			type: String,
			default: ''
		}
	},
	setup(props) {
		const bookId = computed(() => {
			return props.bookId;
		});
		const uid = computed(() => {
			return store.state.reader.user.uid;
		});
		const institution = computed(() => {
			return store.state.reader.institution;
		});
		const isLibLink = ref(false); // 是否有馆藏链接
		const bookDetails = ref({});
		const catalogs = ref([]); // 章节
		const moreCatalog = ref(false);
		const vendorName = ref(''); // 供应商
		const onBookDetail = () => {
			getBookdetails(bookId.value)
					.then(data => {
						if (data) {
							bookDetails.value = data;
							if (bookDetails.value.vendorId) {
								onVendor(bookDetails.value.vendorId);
							}
							if (!isNotEmpty(bookDetails.value.coverUrl) && isNotEmpty(bookDetails.value.isbn)) {
								setCovers([bookDetails.value.isbn],[bookDetails.value]);
							}
							if (bookDetails.value.chapter) {
								catalogs.value = bookDetails.value.chapter.split('\n');
							} else {
								catalogs.value = [];
							}
							if (uid.value && data.isbn && data.title) {
								onCheckDuplicate(data.isbn, data.title);
							}
						}
					})
					.catch((error) => {
						console.error(error);
					});
		};
		// 供应商
		const onVendor = (vendorId) => {
			getOrderVendor(vendorId)
					.then(data => {
						if (data) {
							vendorName.value = data.vendorName;
						}
					})
					.catch((error) => {
						console.error(error);
					});
		};
		const onCheckDuplicate = (isbn, title) => {
			checkDuplicate(isbn, title)
					.then(data => {
						if (data && data.isDuplicate) {
							let link = '';
							if (data['pda.check.duplicate.title']) {
								link = `isbn=${bookDetails.value.isbn}&title=${bookDetails.value.title}`;
							} else {
								link = `isbn=${bookDetails.value.isbn}`;
							}
							isLibLink.value = getLibLink(link);
						}
					})
					.catch((error) => {
						console.error(error);
					});
		};
		function handleErrorImage(event){
			event.srcElement.src = randomBookCover();
		}
		function defaultCover(){
			return randomBookCover();
		}
		watch(
				bookId, () => {
					if (isNotEmpty(bookId.value)) {
						onBookDetail();
					}
				},
				{immediate: true}
		);
		return {
			bookId,
			bookDetails,
			catalogs,
			moreCatalog,
			vendorName,
			uid,
			institution,
			isLibLink,
			handleErrorImage,
			defaultCover
		}
	}
});
</script>

<style scoped lang="less">
@import "../assets/css/book-detail.less";
</style>
